import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Button = styled.button`
  width: 100%;
  padding: 24px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.green2};
  background-color: ${theme.colors.white};
  border-radius: ${theme.border.mediumRadius};
  border: 2px solid ${theme.colors.green2};
`
